import React from 'react';

import classNames from 'classnames';

import { EXCEPTION_CELL_CLASS, OpenRowButton, orNotSet } from '../HomeSection';

import { formatDateWithYear } from 'Helpers/dateTimeService';

import Badge from 'CommonComponents/Badge';

/* HomeOpenActionRowData's two source values. They arrive from the server in
   English because they identify the table a row came from; the column shows a
   translated label for them. */
const SOURCE_ACTION = 'Action';

/**
 * Plan activities and their actions in one due-date-ordered list.
 *
 * ONE TABLE, NOT TWO STACKED ONES. The list exists so a user can see what is
 * late without deciding first which module it came from, so the Source column
 * says which table a row is from and the ordering ignores it entirely.
 *
 * The rows arrive ordered; nothing is re-sorted here. The server merged the two
 * sources against midnight in the user's own timezone, which the browser's
 * clock cannot be trusted to reproduce.
 */
export default function OpenActionsTable({ rows = [], onRowClick }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Item')}</th>
                        <th className="tw-w-36">{$t('Due')}</th>
                        <th className="tw-w-36">{$t('Source')}</th>
                        <th>{$t('Context')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={`${row.source}-${row.id}`} onClick={() => onRowClick?.(row)} className="tw-cursor-pointer">
                            <td className={classNames({ [EXCEPTION_CELL_CLASS]: row.overdue })}>
                                <OpenRowButton onClick={() => onRowClick?.(row)} label={$t('Open {{item}}', { item: row.item })}>
                                    {row.item}
                                </OpenRowButton>
                            </td>
                            <td className="inbud-date-cell">
                                {orNotSet(row.due_date && formatDateWithYear(row.due_date))}
                                {!!row.overdue && (
                                    <Badge variant="danger" className="tw-ms-2">
                                        {$t('Overdue')}
                                    </Badge>
                                )}
                            </td>
                            <td>{row.source === SOURCE_ACTION ? $t('Action') : $t('Plan activity')}</td>
                            <td>{orNotSet(row.context)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
